import React from "react";
import InputComponent from "./InputComponent";
import TextField from "@mui/material/TextField";

const Control = React.forwardRef(
  (
    {
      children,
      innerProps,
      innerRef,
      selectProps: { TextFieldProps, menuIsOpen },
    },
    ref
  ) => {
    return (
      <TextField
        InputProps={{
          inputComponent: InputComponent,
          inputProps: {
            className: "!flex",
            ref: innerRef,
            children,
            ...innerProps,
          },
        }}
        inputRef={ref}
        {...TextFieldProps}
        sx={{
          border: "none",
          boxShadow:
            TextFieldProps.shadow && !menuIsOpen
              ? TextFieldProps.shadow
              : menuIsOpen
              ? "0px 10px 20px 0px #0000001A"
              : "none !important",
          borderRadius: "10px",
          backgroundColor: TextFieldProps.bgc || "#f8fbff",
          "& div > fieldset": {
            border: "none",
            outline: "none",
          },
        }}
      />
    );
  }
);

Control.displayName = "Control";

export default Control;
